import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import image from '@assets/svg/accessDenied.svg';
import hertzLogo from '@assets/svg/Logo_50hertz.svg';
import amprionLogo from '@assets/svg/Logo_Amprion.png';
import tennetLogo from '@assets/svg/Logo_Tennet.png';
import transnetLogo from '@assets/svg/Logo_TransnetBW.png';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

const centerColumnFlex = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-start',
};

const openSansText = {
  fontFamily: tsoPqTheme.typography.openSans,
  lineHeight: '1.5625rem',
  fontStyle: 'normal',
  listStyle: 'inside',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
};

const createStyledBox = (styles: any) => styled(Box)(() => styles);

const StyledAccessDenied = createStyledBox({
  height: '100vh',
  boxSizing: 'border-box',
  width: '100vw',
  ...centerColumnFlex,
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background,
  paddingTop: '0rem',
});

const StyledAccessDeniedTitle = createStyledBox({
  textAlign: 'center',
  whiteSpace: 'pre-line',
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '3rem',
  lineHeight: '4.1875rem',
  fontWeight: '400',
  paddingLeft: '5rem',
  paddingRight: '5rem',
  color: tsoPqTheme.palette.customTextColor.color_primary_font_ft_prim_enabled,
  boxSizing: 'border-box',
  width: '100%',
});

const StyledAccessDeniedWrapper = createStyledBox({
  boxSizing: 'border-box',
  height: '100%',
  width: '76.5rem',
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
  alignSelf: 'center',
  paddingTop: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
  paddingBottom: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
  ...centerColumnFlex,
});

const StyledAccessDeniedImageWrapper = createStyledBox({
  padding: '1.5rem',
  gap: '0.625rem',
  alignSelf: 'center',
  ...centerColumnFlex,
});

const StyledAccessDeniedLogoWrapper = createStyledBox({
  alignSelf: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  maxWidth: '100%',
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
});

const StyledImage = styled('img')({
  width: '32.75rem',
  height: 'auto',
});

const StyledAccessDeniedTextWrapper = createStyledBox({
  textAlign: 'center',
  paddingLeft: '5rem',
  paddingRight: '5rem',
  width: '100%',
  boxSizing: 'border-box',
  gap: '1.75rem',
  ...centerColumnFlex,
});

const StyledAccessDeniedFooterWrapper = createStyledBox({
  boxSizing: 'border-box',
  width: '76.5rem',
  height: '100%',
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
  alignSelf: 'center',
  paddingLeft: '6.5rem',
  paddingRight: '6.5rem',
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  paddingBottom: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_32,
});

const StyledAccessDeniedFooterTextWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

const StyledAccessDeniedFooterLine = createStyledBox({
  flex: '1',
  height: '0.016rem',
  backgroundColor: tsoPqTheme.palette.stroke.color_neutral_stroke_str_ntrl_accent,
});

const StyledAccessDeniedFooterDescription = createStyledBox({
  ...openSansText,
  fontSize: '0.875rem',
  textAlign: 'left',
  fontWeight: '400',
});

const StyledAccessDeniedFooterLogo = styled('img')({
  width: '6.125rem',
  height: 'auto',
});

const AccessDeniedPage = () => {
  const { t } = useTranslation();

  return (
    <StyledAccessDenied>
      <StyledAccessDeniedWrapper>
        <StyledAccessDeniedTitle>{t('accessDenied.title')}</StyledAccessDeniedTitle>
        <StyledAccessDeniedImageWrapper>
          <StyledImage src={image} alt="" />
        </StyledAccessDeniedImageWrapper>
        <StyledAccessDeniedTextWrapper>
          <TypographyTsoPq typographyType="bodyTextMD">{t('accessDenied.description1')}</TypographyTsoPq>
          <TypographyTsoPq typographyType="bodyTextMD">{t('accessDenied.description2')}</TypographyTsoPq>
        </StyledAccessDeniedTextWrapper>
      </StyledAccessDeniedWrapper>
      <StyledAccessDeniedFooterWrapper>
        <StyledAccessDeniedFooterTextWrapper>
          <StyledAccessDeniedFooterLine />
          <StyledAccessDeniedFooterDescription>
            {t('accessDenied.footer.description')}
          </StyledAccessDeniedFooterDescription>
          <StyledAccessDeniedFooterLine />
        </StyledAccessDeniedFooterTextWrapper>
        <StyledAccessDeniedLogoWrapper>
          <StyledAccessDeniedFooterLogo src={hertzLogo} alt="" />
          <StyledAccessDeniedFooterLogo src={amprionLogo} alt="" />
          <StyledAccessDeniedFooterLogo src={tennetLogo} alt="" />
          <StyledAccessDeniedFooterLogo src={transnetLogo} alt="" />
        </StyledAccessDeniedLogoWrapper>
      </StyledAccessDeniedFooterWrapper>
    </StyledAccessDenied>
  );
};
export default AccessDeniedPage;
